import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-company-loader',
  standalone: true,
  imports: [],
  templateUrl: './company-loader.component.html',
  styleUrls: ['./company-loader.component.scss']
})
export class CompanyLoaderComponent {
  @Input() fullSize = false;
}
